import { useContext } from "react";
import { useQuery } from "react-query";

import { useOrg } from "@hooks/useOrg";
import { PermissionsContext } from "@providers";
import { Feature } from "@utils";

import { fetchPoliciesIfPermitted } from "@pages/policies/api";
import { NOLICY_POLICIES } from "@pages/ruleBoard/constants";

/*
 * Returns query result with policies (and rulesets) from current selected org.
 * If the org is a nolicy org, it will return only nolicy policies (but all rulesets)
 */
export const usePolicies = (withStats: boolean = true) => {
  const org = useOrg();
  const { permissions } = useContext(PermissionsContext);
  const isNolicy = Feature.isNolicy({ org });

  return useQuery(
    ["policies", { org, withStats }],
    () =>
      fetchPoliciesIfPermitted(org?.id!, permissions, withStats).then(
        (response) =>
          isNolicy
            ? {
                policies: response.policies.filter((p) =>
                  NOLICY_POLICIES.some(
                    (rule_board_column) => rule_board_column.slug === p.slug
                  )
                ),
                rulesets: response.rulesets,
              }
            : response
      ),
    {
      enabled: !!org,
    }
  );
};
